import {
  IAIVideoModel,
  IAIVideoProject,
  IReferenceMediaImage
} from 'types/aiVideo'
import { filterValidImages } from 'utils/aiImage'
import { getDefaultAIVideoModel } from '../utils'
import { DEFAULT_MEDIA_DURATION } from 'consts'

// Filters out reference images that may have been deleted from user's files
const filterExistingImages = async (images: IReferenceMediaImage[]) => {
  const results = await Promise.all(
    images.map(async image => {
      const validImages = await filterValidImages([image.url])
      return validImages.length > 0 ? image : null
    })
  )
  return results.filter(image => image !== null)
}

export const processAIVideoImageUrl = async (project: IAIVideoProject) => {
  if (!project?.referenceMedias?.images) {
    return project
  }

  return {
    ...project,
    referenceMedias: {
      ...project.referenceMedias,
      images: await filterExistingImages(project.referenceMedias.images)
    }
  }
}

export const getVerifiedModel = (
  modelName: string,
  aiVideoModels: IAIVideoModel[]
) => {
  const model = aiVideoModels.find(model => model.model === modelName)
  return model || getDefaultAIVideoModel(aiVideoModels)
}

export const getClosestPossibleVideoDuration = (
  duration?: number,
  selectedModel?: IAIVideoModel
) => {
  if (!duration || !selectedModel) {
    return DEFAULT_MEDIA_DURATION
  }
  const possibleDurations = selectedModel.options.map(option => option.duration)
  return possibleDurations.reduce((closest, current) => {
    return Math.abs(current - duration) < Math.abs(closest - duration)
      ? current
      : closest
  }, possibleDurations[0])
}
